import { Formik, Field, Form, ErrorMessage } from "formik";
import {
  handleError,
  handleSuccess,
} from "../../../utils";
import http from "../../../core/service/http";
import { useMyProfileHook } from "./useMyProfileHook";

const MyProfile = () => {
  const {
    initialValues,
    validationSchema,
    onFileChangeHandler,
    getData 
  } = useMyProfileHook();

  return (
    <div className="container h-100 my-5">
      <div className="row">
        <div className="col-md-12">
          <legend className="text-center header text-success mb-3">
            <h4>KHURRAM RAZA PROFILE</h4>
          </legend>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={async (values, { setSubmitting }) => {
              setSubmitting(true);
              try {
                const response = await http.put("/v1/users/", values);
                handleSuccess("Information updated successfully!");
                getData();
              } catch (error) {
                if (error.response) {
                  handleError(error.response.data.message);
                } else {
                  handleError("Network error. Please try again later.");
                }
              }
              setSubmitting(true);
            }}
          >
            {({
              errors,
              touched,
              setFieldValue,
              handleChange,
              isSubmitting,
            }) => (
              <Form>
                <div className="row mb-3">
                  {/* First Name */}
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="firstName" className="required mb-2">
                        Member ID: <span className="required-icon"> *</span>
                      </label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text p-spacing">
                            <i className="fa fa-user bigicon"></i>
                          </span>
                        </div>
                        <Field
                          id="member_id"
                          name="member_id"
                          type="text"
                          placeholder="Member ID"
                          className={`form-control ${
                            errors.firstName && touched.firstName
                              ? "field-error"
                              : ""
                          }`}
                        />
                      </div>
                      <ErrorMessage
                        name="member_id"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </div>

                  {/* Last Name */}
                </div>
                <div className="row mb-3">
                  {/* First Name */}
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="firstName" className="required mb-2">
                        First Name: <span className="required-icon"> *</span>
                      </label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text p-spacing">
                            <i className="fa fa-user bigicon"></i>
                          </span>
                        </div>
                        <Field
                          id="firstName"
                          name="firstName"
                          type="text"
                          placeholder="First Name"
                          className={`form-control ${
                            errors.firstName && touched.firstName
                              ? "field-error"
                              : ""
                          }`}
                        />
                      </div>
                      <ErrorMessage
                        name="firstName"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </div>

                  {/* Last Name */}
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="lastName" className="required mb-2">
                        Last Name: <span className="required-icon"> *</span>
                      </label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text p-spacing">
                            <i className="fa fa-user bigicon"></i>
                          </span>
                        </div>
                        <Field
                          id="lastName"
                          name="lastName"
                          type="text"
                          placeholder="Last Name"
                          className={`form-control ${
                            errors.lastName && touched.lastName
                              ? "field-error"
                              : ""
                          }`}
                        />
                      </div>
                      <ErrorMessage
                        name="lastName"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </div>
                </div>

                <div className="row mb-3">
                  {/* Phone Number */}
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="phone" className="required mb-2">
                        Contact Number:{" "}
                        <span className="required-icon"> *</span>
                      </label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text p-spacing">
                            <i className="fa fa-phone bigicon"></i>
                          </span>
                        </div>
                        <Field
                          id="phone"
                          name="phone"
                          type="text"
                          placeholder="Phone/Cell"
                          className={`form-control ${
                            errors.phone && touched.phone ? "field-error" : ""
                          }`}
                        />
                      </div>
                      <ErrorMessage
                        name="phone"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </div>
                </div>

                <div className="row mb-3">
                  {/* Address */}
                  <div className="col-md-12">
                    <div className="form-group">
                      <label htmlFor="address" className="required mb-2">
                        Address: <span className="required-icon"> *</span>
                      </label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text p-spacing">
                            <i className="fa fa-address-book bigicon"></i>
                          </span>
                        </div>
                        <Field
                          id="address"
                          name="address"
                          type="text"
                          placeholder="Address"
                          className={`form-control ${
                            errors.address && touched.address
                              ? "field-error"
                              : ""
                          }`}
                        />
                      </div>
                      <ErrorMessage
                        name="address"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </div>
                </div>

                <div className="row mb-3">
                  {/* Country */}
                  <div className="col-md-5">
                    <div className="form-group">
                      <label htmlFor="country" className="required mb-2">
                        Country: <span className="required-icon"> *</span>
                      </label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text p-spacing">
                            <i className="fa fa-globe bigicon"></i>
                          </span>
                        </div>
                        <Field
                          id="country"
                          name="country"
                          type="text"
                          placeholder="Country"
                          className={`form-control ${
                            errors.country && touched.country
                              ? "field-error"
                              : ""
                          }`}
                        />
                      </div>
                      <ErrorMessage
                        name="country"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </div>

                  {/* City */}
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="city" className="required mb-2">
                        City: <span className="required-icon"> *</span>
                      </label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text p-spacing">
                            <i className="fa fa-globe bigicon"></i>
                          </span>
                        </div>
                        <Field
                          id="city"
                          name="city"
                          type="text"
                          placeholder="City"
                          className={`form-control ${
                            errors.city && touched.city ? "field-error" : ""
                          }`}
                        />
                      </div>
                      <ErrorMessage
                        name="city"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </div>

                  {/* Zip */}
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor="zip" className="required mb-2">
                        Zip: <span className="required-icon"> *</span>
                      </label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text p-spacing">
                            <i className="fa fa-map-pin bigicon"></i>
                          </span>
                        </div>
                        <Field
                          id="zip"
                          name="zip"
                          type="text"
                          placeholder="Zip"
                          className={`form-control ${
                            errors.zip && touched.zip ? "field-error" : ""
                          }`}
                        />
                      </div>
                      <ErrorMessage
                        name="zip"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </div>
                </div>

                <div className="row mb-3">
                  {/* First Name */}
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor="firstName" className="required mb-2">
                        Choose One Of The Below:{" "}
                        <span className="required-icon"> *</span>
                      </label>
                      <Field
                        as="select"
                        id="billOption"
                        value={initialValues.billOption}
                        name="billOption"
                        className={`form-select  ${
                          errors.billOption && touched.billOption
                            ? "field-error"
                            : ""
                        }`}
                      >
                        <option value="" disabled>
                          Select an option
                        </option>
                        <option value="Driving License">Driving License</option>
                        <option value="Passport">Passport</option>
                      </Field>
                      <ErrorMessage
                        name="billOption"
                        component="div"
                        className="text-danger"
                      />
                      <div className="input-group mt-2">
                        <div className="input-group-prepend">
                          <span className="input-group-text p-spacing">
                            <i className="fa fa-file"></i>
                          </span>
                        </div>
                        <Field
                          id="bill"
                          name="bill"
                          type="file"
                          onChange={(e) => {
                            handleChange(e);
                            onFileChangeHandler(e, setFieldValue, "billBase64");
                          }}
                          className={`form-control ${
                            errors.bill && touched.bill ? "field-error" : ""
                          }`}
                        />
                      </div>
                      <ErrorMessage
                        name="bill"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </div>

                  {/* Last Name */}
                </div>
                <div className="row mb-3">
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor="lastName" className="required mb-2">
                        Utility Bill: <span className="required-icon"> *</span>
                      </label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text p-spacing">
                            <i className="fa fa-file"></i>
                          </span>
                        </div>
                        <Field
                          id="driving_license"
                          name="driving_license"
                          onChange={(e) => {
                            handleChange(e);
                            onFileChangeHandler(
                              e,
                              setFieldValue,
                              "licenseBase64"
                            );
                          }}
                          type="file"
                          className={`form-control ${
                            errors.driving_license && touched.driving_license
                              ? "field-error"
                              : ""
                          }`}
                        />
                      </div>
                      <ErrorMessage
                        name="driving_license"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor="lastName" className="required mb-2">
                        Upload Profile Picture:
                      </label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text p-spacing">
                            <i className="fa fa-file"></i>
                          </span>
                        </div>
                        <Field
                          id="profile_picture"
                          name="profile_picture"
                          type="file"
                          className="form-control"
                          onChange={(e) => {
                            handleChange(e);
                            onFileChangeHandler(
                              e,
                              setFieldValue,
                              "profilePictureBase64"
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Submit Button */}
                <div className="row my-4">
                  <div className="col-md-4">
                    <button
                      type="submit"
                      className="btn btn-success py-2 px-4 btn-lg"
                    >
                      {isSubmitting && (
                        <i className="fas fa-spinner fa-spin"></i>
                      )}
                      {!isSubmitting && "Update and Proceed"}
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger py-2 px-4 mx-2 btn-lg"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default MyProfile;
